export default __webpack_public_path__ + "static/media/Data-Driven-Maintenance.845732bb.pdf";